import * as React from "react";
import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { ChartFooter, ChartHeader } from "components/Dashboard";
import mattersOpened from "../../assets/DashboardIcons/mattersOpened.svg";
import styles from "./DashboardPage.module.scss";
import { useDashboardData } from "services/dashboardService";

export const MattersChart = (props) => {
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const initialSeries = [
    { name: "Matters Opened", data: [] },
    { name: "Matters Closed", data: [] },
  ];

  // Use our new dashboard service hook
  const { data: dashboardData, loading } = useDashboardData();
  const mattersOpenedData = dashboardData?.matters;

  const onSeriesClick = (e) => {
    const data = {
      groupedBy: "Month",
      groupingByParameter: e.category,
      filters: props.filters,
    };
    navigate("/feeearner/mymatters", { state: data });
  };

  useEffect(() => {
    if (mattersOpenedData?.data) {
      const data = mattersOpenedData.data;
      if (!data || !Array.isArray(data)) {
        setCategories([]);
        setSeries(initialSeries.map((s) => ({ ...s, data: [] })));
        return;
      }

      const categories = [];
      const series = initialSeries.map((s) => ({ ...s, data: [] }));

      data.forEach((item) => {
        categories.push(item.key);
        series[0]?.data?.push(
          item.actual !== undefined ? item.actual : item.mattersOpened
        );
        series[1]?.data?.push(
          item.target !== undefined ? item.target : item.mattersClosed
        );
      });

      setCategories(categories);
      setSeries(series);
    } else {
      setCategories([]);
      setSeries(initialSeries.map((s) => ({ ...s, data: [] })));
    }
  }, [mattersOpenedData?.data]);

  if (loading) {
    return (
      <div className="h-100 p-2">
        <ChartHeader
          name={"Matter Opened"}
          type={"(Opened vs Closed)"}
          icon={mattersOpened}
          duration={props.filters?.duration}
          color={"#F1F4FF"}
        />
        <div className="h-100 p-2 d-flex align-items-center justify-content-center">
          <div className="text-muted">Loading matters data...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-100 p-2">
      <ChartHeader
        name={"Matter Opened"}
        type={"(Opened vs Closed)"}
        icon={mattersOpened}
        duration={props.filters?.duration}
        color={"#F1F4FF"}
      />
      {loading ? (
        <div className="h-100 p-2 d-flex align-items-center justify-content-center">
          <div className="text-muted">Loading matters data...</div>
        </div>
      ) : (
        <>
          <div className="p-2">
            <Chart
              style={{ height: "200px", width: "100%", overflow: "hidden" }}
              transitions={false}
              seriesColors={["#262626", "#8079FE"]}
            >
              <ChartCategoryAxis>
                <ChartCategoryAxisItem categories={categories} />
              </ChartCategoryAxis>
              <ChartSeries>
                <ChartSeriesItem type="line" data={series[0]?.data} />
                <ChartSeriesItem type="line" data={series[1]?.data} />
              </ChartSeries>
            </Chart>
          </div>
          <ChartFooter param1={"Opened"} param2={"Closed"} data={series} />
        </>
      )}
    </div>
  );
};

export const MattersStatsCard = () => {
  const { data: dashboardData, loading } = useDashboardData();
  const mattersOpenedData = dashboardData?.matters;

  const totalActual =
    mattersOpenedData?.data?.reduce(
      (sum, item) => sum + (item.mattersOpened ?? 0),
      0
    ) || 0;

  return (
    <div className="d-flex flex-column align-items-start mt-4 py-3 px-4">
      <div
        className={styles.iconContainer}
        style={{ backgroundColor: "#F1F4FF" }}
      >
        <img src={mattersOpened} alt="matters icon" />
      </div>
      <p className="fs-md fw-semibold mt-1 mb-1" style={{ color: "#5379FF" }}>
        Matters Opened
      </p>

      {loading ? (
        <span className="text-muted">Loading...</span>
      ) : (
        <p className="fs-lg fw-bold">{totalActual}</p>
      )}
    </div>
  );
};
